export const en = {
  header: 'Complete your Setup',
}

export const es = en
